import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Box,
  Card,
  Stack,
  Container,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  CardHeader,
  ListItemText,
  Button,
  CircularProgress
} from '@mui/material';
import Page from '../components/Page';
import { api, mainurl } from 'src/Api';
import { LoadingButton, TabContext, TabPanel } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import { Link, useNavigate } from 'react-router-dom';

import OtpInput from 'react-otp-input';
import { useTheme } from '@emotion/react';
import { fCurrency } from 'src/utils/formatNumber';
import { useBoolean } from 'src/hooks/use-boolean';
import { fDate } from 'src/utils/formatTime';

export default function Settings() {
  const theme = useTheme();
  const showMore = useBoolean();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  const borkerPlans = [
    {
      title: '1 Month',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '99.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #7151A5, #C4B5FD)',
      checkColor: '#7151A5',
      price_id: 'price_1QWzaVECi7NW6H84hd5VTYBV',
      id: 1
    },
    {
      title: '3 Month',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '259.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #E58D00, #FCD34D)',
      checkColor: '#E58D00',
      price_id: 'price_1QWzb4ECi7NW6H84N5dbEAGP',
      id: 2
    },
    {
      title: '1 Year',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '999.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #388855, #69c289)',
      checkColor: '#388855',
      price_id: 'price_1QWzbUECi7NW6H84jmwuvmlA',
      id: 3
    }
  ];
  const shiperData = [
    {
      title: '1 Month',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '49.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #7151A5, #C4B5FD)',
      checkColor: '#7151A5',
      price_id: 'price_1QWzSsECi7NW6H84Fs7UXh5H',
      id: 1
    },
    {
      title: '3 Month',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '135.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #E58D00, #FCD34D)',
      checkColor: '#E58D00',
      price_id: 'price_1QWzTbECi7NW6H84OjvzbqtH',
      id: 2
    },
    {
      title: '1 Year',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '499.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #388855, #69c289)',
      checkColor: '#388855',
      price_id: 'price_1QWzUXECi7NW6H84TbcK0Vit',
      id: 3
    }
  ];
  const truckerData = [
    {
      title: '1 Month',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '49.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #7151A5, #C4B5FD)',
      checkColor: '#7151A5',
      price_id: 'price_1QWzVnECi7NW6H84dOgSQoNp',
      id: 1
    },
    {
      title: '3 Month',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '135.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #E58D00, #FCD34D)',
      checkColor: '#E58D00',
      price_id: 'price_1QWzWKECi7NW6H84sdiK01vl',
      id: 2
    },
    {
      title: '1 Year',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '499.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #388855, #69c289)',
      checkColor: '#388855',
      price_id: 'price_1QWzWqECi7NW6H84h2dQPifb',
      id: 3
    }
  ];
  const couriersData = [
    {
      title: '1 Month',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '49.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #7151A5, #C4B5FD)',
      checkColor: '#7151A5',
      price_id: 'price_1QWzXYECi7NW6H84ElZXjzYw',
      id: 1
    },
    {
      title: '3 Month',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '135.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #E58D00, #FCD34D)',
      checkColor: '#E58D00',
      price_id: 'price_1QWzYDECi7NW6H84O8pR2Yg2',
      id: 2
    },
    {
      title: '1 Year',
      features: [
        'Lorem ipsum dolor',
        'Sit amet consectetur',
        'Adipiscing elit sed',
        'Do eiusmod tempor'
      ],
      price: '499.00',
      period: 'PRICE CREDIT',
      gradient: 'linear-gradient(135deg, #388855, #69c289)',
      checkColor: '#388855',
      price_id: 'price_1QWzZVECi7NW6H841oSln80D',
      id: 3
    }
  ];

  const [selectedTab, setSelectedTab] = useState(0);
  const [email, setEmail] = useState(userData?.email);
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState('');
  const [ShowNewEmailInput, setShowNewEmailInput] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [showPassword, setShowPassword] = useState(false);
  const [issubmiting, setissubmiting] = useState(false);
  const [values, setValues] = useState({
    oldpassword: '',
    password: '',
    confirm: ''
  });
  const [billingPlans, setBillingPlans] = useState([]);
  const [subscriptionsItems, setSubscriptionsItems] = useState([
    {
      name: '1 Month',
      id: 1
    },
    {
      name: '3 Month',
      id: 2
    },
    {
      name: '1 Year',
      id: 3
    }
  ]);

  const [loading, setLoading] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [loadingCancelSubscription, setLoadingCancelSubscription] = useState(false);
  const [loadingGetSubscriptions, setLoadingGetSubscriptions] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loadingGetPlans, setLoadingGetPlans] = useState(false);

  
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    setUserData(storedUser);
  }, []);

  useEffect(() => {
    if (userData?.id) {
      get_subscriptions();
    }
  }, [userData?.id]);

  useEffect(() => {
    if (userData) {
      getBillingPlans();
    }
  }, [selectedPlanId, userData]);
  useEffect(() => {
    if (userData?.subscription?.type === 'paid') {
      const startDate = new Date(userData?.subscription?.start_date); // Convert to Date object
      const endDate = new Date(userData?.subscription?.end_date);
  
      // Calculate the total months difference
      const totalMonths =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());
  
      // Check for partial month
      const isPartialMonth = endDate.getDate() > startDate.getDate();
  
      const differenceInMonths = isPartialMonth ? totalMonths + 1 : totalMonths;
  
      if (differenceInMonths < 12) {
        setSelectedPlanId(`${differenceInMonths} Month`);
      } else {
        const years = Math.floor(differenceInMonths / 12);
        setSelectedPlanId(`${years} Year`);
      }
    } else {
      setSelectedPlanId('1 Month');
    }
  }, [userData]);
  useEffect(() => {
    if (userData?.role?.role_name.toLowerCase() === 'broker') {
      setBillingPlans(borkerPlans);
    } else if (userData?.role?.role_name.toLowerCase() === 'shiper') {
      setBillingPlans(shiperData);
    } else if (userData?.role?.role_name.toLowerCase() === 'truck driver') {
      setBillingPlans(truckerData);
    } else if (userData?.role?.role_name.toLowerCase() === 'courier') {
      setBillingPlans(couriersData);
    }
  }, [userData]);

  const getBillingPlans = () => {
    setLoadingGetPlans(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `${api.get_packages}?role_id=${userData?.role?.id}&duration=${selectedPlanId}`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else {
          return response.json().then((error) => {});
        }
      })
      .then((result) => {
        setBillingPlans(result.data);
      })
      .catch((error) => {})
      .finally(() => {
        setLoadingGetPlans(false);
      });
  };

  const otpInputStyle = {
    width: '100%',
    height: '56px',
    textAlign: 'center',
    fontSize: '18px',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: '6px',
    border: `1px solid ${theme.palette.primary.main} !important`
  };

  const otpContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    padding: '20px 20%'
  };

  const resetFunction = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('current_password', values?.oldpassword);
    formdata.append('new_password', values?.password);
    formdata.append('new_password_confirmation', values?.confirm);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.reset_password, requestOptions)
      .then((response) =>
        response.text().then((result_) => ({ status: response.status, body: result_ }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);

        if (status === 201 || status == 200) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setValues({
            oldpassword: '',
            password: '',
            confirm: ''
          });
          navigate('/dashboard/app');
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  const sendOtpFunction = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.change_email_otp, requestOptions)
      .then((response) =>
        response.text().then((result_) => ({ status: response.status, body: result_ }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);

        if (status === 201 || status == 200) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setShowOTP(true);
          setOtp('');
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  const handleOTPVerify = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('otp', otp);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.otp_verify, requestOptions)
      .then((response) =>
        response.text().then((result_) => ({ status: response.status, body: result_ }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);

        if (status === 201 || status == 200) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setShowOTP(false);
          setShowNewEmailInput(true);
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  const handleConfirmNewEMail = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('email', newEmail);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.change_email, requestOptions)
      .then((response) =>
        response.text().then((result_) => ({ status: response.status, body: result_ }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);

        if (status === 201 || status == 200) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setShowNewEmailInput(false);
          localStorage.setItem('user', JSON.stringify(result.data));
          localStorage.setItem('email', result.data.email);
          setEmail(result.data.email);
          setNewEmail('');
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); // Switch the tab based on user selection
    setEmail(userData?.email);
    setShowOTP(false);
  };

  // Function to handle the checkout process
  const handleCheckout = async (price_id) => {
    setLoading(true);
    try {
      const response = await fetch(`${mainurl}v1/subscription/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lookup_key: price_id,
          user_id: userData?.id
        })
      });

      const data = await response.json();
      setLoading(false);
      window.location.href = data?.url;
    } catch (error) {
      setLoading(false);
      console.error('Error creating checkout session:', error);
      // setMessage('An error occurred while processing your request.');
    }
  };

  // Function to handle the checkout process
  const handleCancelSubscription = async () => {
    setLoadingCancelSubscription(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(api.cancel_subscription, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const response = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarOpen(true);
          setSnackbarMessage(response.message);
          setSnackbarSeverity('success');
          navigate('/dashboard/app', { replace: true });
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(response.error);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => setLoadingCancelSubscription(false));
  };

  function get_subscriptions() {
    setLoadingGetSubscriptions(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${api.get_subscriptions}?user_id=${userData?.id}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setLoadingGetSubscriptions(false);
          setSubscriptions(result.data);
        } else {
          setLoadingGetSubscriptions(false);
        }
      })
      .catch((error) => {
        setLoadingGetSubscriptions(false);
        console.log('error', error);
      });
  }

  return (
    <Page title={`Settings | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start">
          <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(209,209,209,0.3)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
          </IconButton>
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            Settings
          </Typography>
        </Stack>

        <TabContext value={selectedTab.toString()}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab sx={{ fontSize: '12px' }} label="CHANGE PASSWORD" />
            <Tab sx={{ fontSize: '12px' }} label="CHANGE EMAIL" />
            {userData?.role?.role_name.toLowerCase() !== 'admin' && (
              <Tab sx={{ fontSize: '12px' }} label="BILLING" />
            )}

            {userData?.role?.role_name.toLowerCase() !== 'admin' && (
              <Tab sx={{ fontSize: '12px' }} label="TRANSACTION" />
            )}
          </Tabs>

          <TabPanel value="0" sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}>
            <Card sx={{ p: 3, boxShadow: 2 }}>
              <Box px={0} pb={2}>
                <form>
                  <TextField
                    fullWidth
                    label={'Current Password'}
                    margin="normal"
                    name="oldpassword"
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    value={values.oldpassword}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleShowPassword} edge="end">
                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    className="custom-textfield"
                  />
                  <TextField
                    fullWidth
                    label={'New Password'}
                    margin="normal"
                    name="password"
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    value={values.password}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleShowPassword} edge="end">
                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    className="custom-textfield"
                  />
                  <TextField
                    fullWidth
                    label={'Confirm New Password'}
                    margin="normal"
                    name="confirm"
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    value={values.confirm}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleShowPassword} edge="end">
                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    className="custom-textfield"
                  />
                </form>
              </Box>

              <Box display="flex" justifyContent="flex-end" mt={1}>
                <LoadingButton
                  onClick={resetFunction}
                  color="primary"
                  variant="contained"
                  loading={issubmiting}
                  sx={{ fontSize: 12 }}
                >
                  Change Password
                </LoadingButton>
              </Box>
            </Card>
          </TabPanel>

          <TabPanel value="1" sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}>
            <Card sx={{ p: 3, boxShadow: 2 }}>
              <Box px={0} pb={2}>
                {ShowNewEmailInput ? (
                  <TextField
                    fullWidth
                    label="New Email"
                    onChange={(e) => setNewEmail(e.target.value)}
                    type="email"
                    value={newEmail}
                    variant="outlined"
                    className="custom-textfield"
                  />
                ) : (
                  <TextField
                    disabled={true}
                    fullWidth
                    label="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    value={email}
                    variant="outlined"
                    className="custom-textfield"
                  />
                )}
              </Box>

              {showOTP && (
                <div style={otpContainerStyle}>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderSeparator={<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}
                    renderInput={(props) => <input {...props} style={otpInputStyle} />}
                  />
                </div>
              )}

              <Box display="flex" justifyContent="flex-end" mt={1}>
                {ShowNewEmailInput ? (
                  <LoadingButton
                    onClick={handleConfirmNewEMail}
                    color="primary"
                    variant="contained"
                    loading={issubmiting}
                    sx={{ fontSize: 12 }}
                  >
                    Save
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    onClick={showOTP ? handleOTPVerify : sendOtpFunction}
                    color="primary"
                    variant="contained"
                    loading={issubmiting}
                    sx={{ fontSize: 12 }}
                  >
                    {showOTP ? 'Verify OTP' : 'Change Email'}
                  </LoadingButton>
                )}
              </Box>
            </Card>
          </TabPanel>

          {userData?.role?.role_name.toLowerCase() !== 'admin' && (
            <TabPanel
              value="2"
              sx={{ padding: '0px 15px 0px 0px ', marginTop: 2, marginBottom: 2 }}
            >
              <Card sx={{ p: 3, boxShadow: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id="billing-plan-label">Select Billing Plan</InputLabel>
                  <Select
                    disabled={
                      loading ||
                      loadingCancelSubscription ||
                      userData?.subscription?.type === 'paid'
                    }
                    labelId="billing-plan-label"
                    id="billing-plan-select"
                    value={selectedPlanId}
                    label="Select Billing Plan"
                    onChange={(event) => setSelectedPlanId(event.target.value)}
                  >
                    {subscriptionsItems.map((plan, index) => (
                      <MenuItem
                        key={index}
                        value={plan.name}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%'
                        }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography variant="subtitle1">{plan.name}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {loadingGetPlans && (
                  <div
                    style={{
                      height: 245,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <CircularProgress
                      sx={{ color: '#010f58', textAlign: 'center', mt: 5, mb: 5 }}
                    />
                  </div>
                )}

                {/* New Card to display selected plan details */}
                {selectedPlanId && !loadingGetPlans && (
                  <Card
                    sx={{
                      mt: 3,
                      p: 3,
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 2,
                      background: (theme) => theme.palette.background.neutral
                    }}
                  >
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      Selected Plan Details
                    </Typography>

                    {billingPlans.map((plan) => (
                      <Box key={plan.amount}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                          <Typography variant="subtitle1" color="text.secondary">
                            Plan Duration
                          </Typography>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            {plan.duration}
                          </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                          <Typography variant="subtitle1" color="text.secondary">
                            Price
                          </Typography>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            ${plan.amount}
                          </Typography>
                        </Box>
                        {userData?.subscription?.type === 'paid' ? (
                          <LoadingButton
                            onClick={handleCancelSubscription}
                            color="primary"
                            variant="contained"
                            loading={loadingCancelSubscription}
                            sx={{ fontSize: 12, mt: 2, width: '100%' }}
                          >
                            Cancel
                          </LoadingButton>
                        ) : (
                          <LoadingButton
                            onClick={() => handleCheckout(plan.price_id)}
                            color="primary"
                            variant="contained"
                            loading={loading}
                            sx={{ fontSize: 12, mt: 2, width: '100%' }}
                          >
                            Subscribe
                          </LoadingButton>
                        )}
                      </Box>
                    ))}
                  </Card>
                )}
              </Card>
            </TabPanel>
          )}

          {userData?.role?.role_name.toLowerCase() !== 'admin' && (
            <TabPanel
              value="3"
              sx={{ padding: '0px 15px 0px 0px ', marginTop: 2, marginBottom: 2 }}
            >
              <Card sx={{ boxShadow: 2 }}>
                {loadingGetSubscriptions ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress
                      sx={{ color: '#010f58', textAlign: 'center', mt: 5, mb: 5 }}
                    />
                  </div>
                ) : (
                  <>
                    <CardHeader title="Transaction history" />

                    {subscriptions.length === 0 ? (
                      <Typography
                        variant="body2"
                        sx={{ color: '#010f58', textAlign: 'center', mt: 2, mb: 2 }}
                      >
                        No transactions available. Your transaction history will appear here once
                        transactions are made.
                      </Typography>
                    ) : (
                      <>
                        <Stack spacing={1.5} sx={{ px: 3, pt: 3, minHeight: 255 }}>
                          {(showMore.value ? subscriptions : subscriptions?.slice(0, 5))?.map(
                            (invoice) => {
                              return (
                                <Stack key={invoice.id} direction="row" alignItems="center">
                                  <ListItemText
                                    primary={invoice.payment_id}
                                    secondary={`Start : ${fDate(
                                      invoice.start_date
                                    )} | End : ${fDate(invoice.end_date)}`}
                                    primaryTypographyProps={{
                                      typography: 'body2',
                                      fontWeight: 'bold',
                                      color: '#010f58'
                                    }}
                                    secondaryTypographyProps={{
                                      mt: 0.5,
                                      component: 'span',
                                      typography: 'caption',
                                      color: 'text.disabled'
                                    }}
                                  />

                                  <Typography variant="body2" sx={{ textAlign: 'right', mr: 5 }}>
                                    {fCurrency(invoice.amount)}
                                  </Typography>

                                  <Typography
                                    variant="body2"
                                    sx={{
                                      textAlign: 'right',
                                      mr: 5,
                                      textTransform: 'capitalize',
                                      width: '100px'
                                    }}
                                  >
                                    {`(${invoice.type})`}
                                    {/* {invoice.type === null ? '(Free Trial)' : `(${invoice.type})`} */}
                                  </Typography>

                                  {invoice.type !== 'trail' ? (
                                    <Link
                                      sx={{ color: 'blue', fontWeight: 'bold' }}
                                      underline="always"
                                      to={invoice?.payment_url}
                                    >
                                      PDF
                                    </Link>
                                  ) : (
                                    <div style={{ width: '33px' }} />
                                  )}
                                </Stack>
                              );
                            }
                          )}

                          {subscriptions?.length > 5 && <Divider sx={{ borderStyle: 'dashed' }} />}
                        </Stack>

                        {subscriptions?.length > 5 && (
                          <Stack alignItems="flex-start" sx={{ p: 2 }}>
                            <Button
                              size="small"
                              color="inherit"
                              startIcon={
                                <Iconify
                                  width={16}
                                  icon={
                                    showMore.value
                                      ? 'eva:arrow-ios-upward-fill'
                                      : 'eva:arrow-ios-downward-fill'
                                  }
                                  sx={{ mr: -0.5 }}
                                />
                              }
                              onClick={showMore.onToggle}
                            >
                              Show {showMore.value ? `less` : `more`}
                            </Button>
                          </Stack>
                        )}
                      </>
                    )}
                  </>
                )}
              </Card>
            </TabPanel>
          )}
        </TabContext>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
